<!-- 在线联系 -->
<template>
  <div>
    <div class="section_36 flex-col">
      <img
        class="label_8"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng66ae524d46a63d252d809d5856703266b56b1219c982dc08ff4ce172dded4ab3"
      />
      <span class="text_98" @click="gotoweixin">在线联系</span>
      <div class="image-wrapper_13 flex-col justify-between">
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          :src="'api' + gaunyuList.tb_erweima"
          @click="openimg"
        />
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          @click="toTop"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbc32b7c0546cc86273a5c29ff9c330573804398d8a4039329e51ed983a91c0cb"
        />
      </div>
    </div>
    <el-dialog :visible.sync="mtk">
      <div class="block" style="display:flex;flex-direction: column;align-items: center;">
        <span class="demonstration" style="font-size:24px; font-weight:600;margin-bottom:20px">扫码加好友，领取学习资料</span>
        <el-image style="width:300px;height:300px"
          :src="'api' + gaunyuList.tb_erweima"
        ></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import hotnew from './hotnew.vue'
import { GetGuanyu } from "../../api/guanyu";
export default {
  props: {},
  data() {
    return {
      gaunyuList: {},
      mtk: false
    };
  },
  created() {
    this.getguanyu();
  },
  computed: {},
  methods: {
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    //客服、工作日、联系地址、微信二维码
    getguanyu() {
      GetGuanyu().then(response => {
        this.gaunyuList = response.data;
        console.log("客服、工作日、联系地址、微信二维码", this.gaunyuList);
      });
    },
    gotoweixin() {
      window.open(this.gaunyuList.tb_customer_link);
    },
    openimg() {
      console.log("123");
      this.mtk = true;
    }
  }
};
</script>

<style scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}
.image_8 {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}
.image_7 {
  width: 50px;
  height: 50px;
}
.image-wrapper_13 {
  width: 50px;
  height: 110px;
  margin-top: 10px;
}
.text_98 {
  width: 49px;
  padding: 13px;
  margin: 20px 0 0 0;
  height: 105px;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 0.8);
  font-size: 16px;
  font-weight: NaN;
  text-align: justify;
  line-height: 20px;
  border: 1px solid #d9d9d9;
  background-color: rgb(255,255,255)
}
.label_8 {
  width: 30px;
  height: 24px;
  margin: 13px 0 0 10px;
}
.section_36 {
  /* background-color: rgba(255, 255, 255, 1);
    width: 50px;
    height: 140px;
    border: 1px solid rgba(238, 238, 238, 1); */
  position: fixed;
  right: -210px;
  top: 65%;
  height: 50px;
  width: 50px;
  margin: 0px 232px 0px 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/article/article.vue